module.exports = __webpack_public_path__ + "img/icons_34.85ce791e.svg";